import Vue from 'vue'
import App from './App'
import router from './router'//vue路由
import store from './store'//vue数据仓库
import dataLeakagePrevention from './assets/js/universaiMethod/dataLeakagePrevention.js'//防止数据泄露(暂未开发)
import ajax from '../src/api/index'
Vue.prototype.$axios = ajax
import ajaxConst from '../src/api/publicConst'
Vue.prototype.$axiosConst = ajaxConst
// import 'babel-polyfill';

// 
// import {memberList} from '../src/api/managerTwoapi.js';
// import {memberList} from '@/api/managerTwoapi.js';
// memberList({});

// import promise from 'es6-promise'
// promise.polyfill();
Vue.config.productionTip = false//去掉vue警告
// import 'babel-polyfill'
// import promise from 'es6-promise'
// promise.polyfill();
// import Router from 'vue-router'
 // 处理使用vur-router中出现路由警告的问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }


import axiosTest from 'axios';
Vue.prototype.$axiosTest = axiosTest;


//公共方法抽离
	//日期、金钱等函数处理
	import utils from './assets/js/universaiMethod/utils.js'
	Vue.prototype.$utils = utils
	//用户信息
	import user from './assets/js/Self-madeLibrary/userData.js'
	Vue.prototype.$user = user
//公共组件抽离
	//文件查看器
	import pdf_look from "./components/paging/pcClient/popupModule/checkTheRelated/pdf_look"
	Vue.component("pdfLook",pdf_look);

//VueCookies引入	cookies用于存储*******************************
	import VueCookies from 'vue-cookies'
	Vue.use(VueCookies)


//echarts引入项目***********************************
	import echarts from 'echarts'
	Vue.prototype.$echarts = echarts

//Element-ui引入***********************
	import ElementUI from 'element-ui';
	import 'element-ui/lib/theme-chalk/index.css';
	Vue.use(ElementUI);
	import {
		Loading
	  } from 'element-ui';
	  import 'element-ui/lib/theme-chalk/index.css';
	import './assets/css/mainStyle.scss';

// 二维码
	import qrCodeA from '@/components/paging/pcClient/sundryModule/qrcode/index'
	Vue.use(qrCodeA)

// PDF文件查看（包含签署意见、签名、盖章）
	import pdfFile from '@/components/paging/pcClient/popupModule/structFile/seal/index'
	Vue.prototype.$pdfFile = pdfFile 

	import downFile from '@/components/paging/pcClient/popupModule/structFile/downFile/index'
	Vue.prototype.$downFile = downFile

// loding加载过渡
	import loding from '@/components/paging/pcClient/popupModule/hint/loding'
	Vue.prototype.$loding = loding
   	

// 引入百度富文本

import '../static/ueditor/ueditor.config.js'
import '../static/ueditor/ueditor.all.min.js'
import '../static/ueditor/lang/zh-cn/zh-cn.js'　　　
import '../static/ueditor/ueditor.parse.min.js'
//vueAxios引入********************************************
/*
 * 写了一个loading  别改了
 */
window.loadingInstance = null
export function loading() {
	window.loadingInstance = Loading.service({
	  lock: true,
	  text: 'Loading',
	  spinner: 'el-icon-loading',
	  background: 'rgba(0, 0, 0, 0.2)'
	});
  }
	import axios from 'axios'
	Vue.prototype.axios = axios
	const ENV = {
		online: 'http://api.jianyitong.com',
		testline: 'http://api.jianyitongtest.com',
		dev:'/3'
	  }

	  const API_ROOT = process.env.NODE_ENV === 'production' ? ENV.online : process.env.NODE_ENV === 'testing' ? ENV.testline : ENV.dev
	// import apn from '../config/transfer-station.js'
	//启用接口链URL
		axios.defaults.baseURL = API_ROOT
		//其他更改联调设置
//		axios.defaults.baseURL = apn.jointDebug['join_A']
	//键值对数据传递模式
		axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
	//json数据传递模式（***暂不启用***）
	//	axios.defaults.headers.post['Content-Type'] = 'application/json';
	//	跨域解决
    axios.defaults.withCredentials = false
		axios.interceptors.request.use(config => {
			//显示loading
			// loading()
			return config
		  }, error => {
			// loadingInstance.close()
		  })

	// http response 拦截器
		axios.interceptors.response.use(
		  	response => {
		  	  if(loadingInstance){
				    loadingInstance.close()
          }
		  		if (response.data.errorCode && response && response.data.errorCode=="ABC001"||response.data.errorCode=="ABC002"||response.data.errorCode=="ABC003"||response.data.errorCode=="ABC004") {
					if(response.data.errorCode == 'ABC004'){
						document.getElementById("delogGlobal").style.display = "block"
					}else {
						router.push({path:'/entrance/login'});
					}
				}
		    	return response;
		  	},
		  error => {
		    if (error.response) {
			  //这个判断是关键，如果返回登陆页面内容了，就刷新当前页面，经后端处理就会跳转到登陆页面了
          if(loadingInstance){
            loadingInstance.close()
          }
		      if (error.response.status == 403) {
					router.push({path:'/entrance/login'});
		      }
		    }
		  }
		);









/* 实例化项目 */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})








// WEBPACK FOOTER //
// ./src/main.js